/**
 * @title rxaddresshelper.js: Sub-module for Rx pages
 * @description This module is used to handle address operations
 * @dependency 
 */
define([], function() {	
	
	var rxAddressHelper = {

		init : function(options) {
			rxAddressHelper.url.MANAGE_ADDRESS_UPDATE = options.updateURL;
			rxAddressHelper.url.MANAGE_ADDRESS_ADD = options.addURL;
			rxAddressHelper.url.MANAGE_ADDRESS_SET_DEFAULT = options.setDefaultURL;			
		},
		
		currentAddressId: '',
		currentAddressType: '',
		
		/**
		 * URL JSON object should be populated via init(options) funtion
		 * @type {Object}
		 */
		url: {
			MANAGE_ADDRESS_UPDATE: '',
			MANAGE_ADDRESS_ADD: '',
			MANAGE_ADDRESS_SET_DEFAULT: ''
		},
		
		/**
		 * Shows address selection dialog when user tries to change it
		 * @param {String} addressId Address Id of displayed address 
		 * @param {String} addressType Address type of displayed address ('S' - shipping, 'B' - billing)
		 */
		showPrescriptionAddressSelectionDialog: function(addressId, addressType) {
			
			COSTCO.util.getAddressBatchPage(addressType, 'FIRSTNAME', 'ASC', '96', function(data) {
				
				rxAddressHelper.currentAddressId = addressId;
				rxAddressHelper.currentAddressType = addressType;
				
				let addressTemplates = {};
				addressTemplates.addressBlock = 'tmpl_choose_address_block';
				addressTemplates.wrapper = 'tmpl_rx_choose_address_wrapper';				
				COSTCO.CAddressSelectionDialog.createModal(addressId, addressType, addressTemplates, {});
			});
		},
		
		/**
		 * Sets address to be default 
		 * @param {String} addressId Address id to be set as default
		 */
		setDefault: function(addressId) {

			COSTCO.Checkout.ajax_update_state({
				url: rxAddressHelper.url.MANAGE_ADDRESS_SET_DEFAULT,
				method: "POST",
				dataType: 'json',
				data: {
					authToken: COSTCO.Checkout.getAuthToken(),
					formdata: encodeURIComponent(JSON.stringify({'id': addressId}))
				},
			});
			
			$('#costcoModal').modal('hide');
		},
		
		/**
		 * Prepares data for add address modal display
		 * @param {String} addressType Type of address to create ('S' - shipping, 'B' - billing)
		 */
		createNewAddress: function(addressType, addressOptions) {
			
			if (addressOptions == undefined) {
				var addressOptions = {};
			}
			
			addressOptions.url = rxAddressHelper.url.MANAGE_ADDRESS_ADD;
			addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
			
			rxAddressHelper.openAddressAddModal(addressType, undefined, 'add', addressOptions);
		},
		
		/**
		 * Prepares data for edit address modal display
		 * @param {String} addressType Type of address to edit ('S' - shipping, 'B' - billing)
		 * @param {Object} obj Address object to be edited
		 */
		editAddress: function(addressType, obj) {
			
			var data;
			
			if (typeof(obj) === 'number') {
				var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
				data = addressJson;
			} else {
				data = obj;
			}
			
			if (data == null) {
				data = window['ajaxAddressObject_' + obj];
			}
			
			if (addressOptions == undefined) {
				var addressOptions = {};
			}
			
			if ($('#address-blocks input:radio:checked').val() == data['id'] ) {
				data['isPrimary'] = '1';
			}
			
			addressOptions.url = rxAddressHelper.url.MANAGE_ADDRESS_UPDATE;
			addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
			
			rxAddressHelper.openAddressAddModal(addressType, data, 'edit', addressOptions);
		},
		
		/**
		 * Opens add/edit address modal
		 * @param {String} addressType Type of address to create ('S' - shipping, 'B' - billing)
		 * @param {Object} addressObj If mode 'edit', address object to prepopulate input fields in modal
		 * @param {String} mode Mode of address modal ('add' - add new address, 'edit' - edit existing address)
		 * @param {String} addressOptions Various options for address add/edit
		 */
		openAddressAddModal: function(addressType, addressObj, mode, addressOptions) {
			
			if (addressOptions.tmplFooterText) {
				var footerText = COSTCO.util.tmpl(addressOptions.tmplFooterText, {});
			}
			
			var openAddress = function(error) {
				let htmlBody = COSTCO.CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
				// if it is edit mode, trigger jQuery validation immediately
	    		if(mode == "edit") {		    		
	    			COSTCO.CAddressForm.validate(addressType, htmlBody);
	    		}
				COSTCO.CAddress.baseModal(addressType, mode, {
					body : htmlBody,
					footerText: footerText,
					primary_event : function() {
						if (COSTCO.CAddressForm.validate(addressType)) {
							COSTCO.CAddressForm.submit(addressType, false, addressOptions);
						}
					}
				});
			}
			
			openAddress(undefined);
			
			$('body').unbind("costco.address.error").bind("costco.address.error", function(event, error) {
				openAddress(error);
			});
		},
		
		/**
		 * Opens info dialog on click "Why?" link in choose address modal
		 */
		showDefaultPharmacyAddressInfoDialog: function() {
			
			COSTCO.dialog.createExtDialogBox({
				title: messages.PRESCRIPTION_PHARMACY__DefaultAddress_DialogText,
				body: COSTCO.util.tmpl('tmpl_rx_default_pharmacy_address_info_dialog',{}),
				close: function() {
					rxAddressHelper.showPrescriptionAddressSelectionDialog(rxAddressHelper.currentAddressId, rxAddressHelper.currentAddressType);
				}
			});
		},
	}
	
	if (typeof window.COSTCO === "undefined") {
		window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxAddressHelper = rxAddressHelper;
	
	return rxAddressHelper;
});



// WEBPACK FOOTER //
// ./js/rx/rxaddresshelper.js